import { Fragment, useEffect, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "highcharts/modules/no-data-to-display";
import { Spin } from "antd";

// ✅ Initialize the module

export const RegistrationAbandonmentView = ({
  data,
  isLoading,
}: {
  data: any;
  isLoading: boolean;
}) => {
  // ✅ Extract values safely
  const registered = data?.AbandonmentRate?.SuccessCount || 0;
  const notCompleted = data?.AbandonmentRate?.NotCompleted || 0;
  const failed = data?.AbandonmentRate?.Failed || 0;
  const error = data?.AbandonmentRate?.Error || 0;
  const chartRef = useRef<HighchartsReact.RefObject>(null);

  // ✅ Check if all values are zero → no data
  const hasData = registered + notCompleted + failed + error > 0;

  const options: Highcharts.Options = {
    chart: {
      type: "pie",
    },
    title: {
      text: "Registration Abandonment",
    },
    lang: {
      noData: "No data found",
    },
    noData: {
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        color: "#666",
      },
    },
    tooltip: {
      pointFormat: "<b>{point.percentage:.1f}%</b>",
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.percentage:.1f} %",
        },
      },
    },
    credits: {
      enabled: false,
    },
    colors: ["#28a745", "#ffc107", "#dc3545", "#6c757d"], // Green, Yellow, Red, Gray
    series: hasData
      ? [
        {
          name: "Status",
          type: "pie",
          data: [
            { name: "Registered", y: registered },
            { name: "Not Completed", y: notCompleted },
            { name: "Failed", y: failed },
            { name: "Error", y: error },
          ],
        },
      ]
      : [], // ✅ No series if no data
  };
  useEffect(() => {
    const chart = chartRef.current?.chart;
    if (chart) {
      if (isLoading) {
        chart.showLoading("Loading data...");
      } else {
        chart.hideLoading();
      }
    }
  }, [isLoading]);
  
return (
    <Fragment>
      <Spin spinning={isLoading}>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </Spin>
    </Fragment>
  );
};
